/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Beginner_1_HeadingInputs */

const en_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we do not do`)
};

const es_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué no hacemos`)
};

const de_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was wir nicht tun`)
};

const zh_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们不做什么`)
};

const ar_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما لا نفعله`)
};

const fr_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que nous ne faisons pas`)
};

const vi_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Những gì chúng tôi không làm`)
};

const sw_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kile tusichokifanya`)
};

const th_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่เราไม่ทำ`)
};

const bs_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta ne radimo`)
};

const ja_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちがしないこと`)
};

const ko_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`우리가 하지 않는 것`)
};

const pt_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que não fazemos`)
};

const it_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa non facciamo`)
};

const sv_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det här gör vi inte`)
};

const nl_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat we niet doen`)
};

const da_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad vi ikke gør`)
};

const nb_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette gjør vi ikke`)
};

const fi_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä emme tee`)
};

const pl_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czego nie robimy`)
};

const ru_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чего мы не делаем`)
};

const tr_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neleri yapmıyoruz`)
};

const hi_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम क्या नहीं करते`)
};

const id_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang tidak kami lakukan`)
};

const ms_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang tidak kami lakukan`)
};

const cs_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co neděláme`)
};

const el_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι δεν κάνουμε`)
};

const he_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה אנחנו לא עושים`)
};

const af_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat ons nie doen nie`)
};

const hu_method_content_step_02_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amit nem csinálunk`)
};

/**
* | output |
* | --- |
* | "What we do not do" |
*
* @param {Method_Content_Step_02_Detail_Beginner_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_beginner_1_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Beginner_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Beginner_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_beginner_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_beginner_1_heading(inputs)
	return en_method_content_step_02_detail_beginner_1_heading(inputs)
});